// extracted by mini-css-extract-plugin
export default {"main":"ModalNuevaNotaProfesor_main__qoiAm","intro":"ModalNuevaNotaProfesor_intro__BI14e","input":"ModalNuevaNotaProfesor_input__Oj25-"};